import { twMerge } from "tailwind-merge";

/** Merge Tailwind classes safely; skips falsy parts. */
export function cn(...parts) {
  return twMerge(parts.filter(Boolean).join(" "));
}
